// extracted by mini-css-extract-plugin
export default {"button":"PaginationButton_button__4-rQS","selected":"PaginationButton_selected__pqK9K"};